// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__32MeX","col":"styles_col__2cYdU","actions":"styles_actions__1KdQ1","conflict":"styles_conflict__19dUj"};